import React, { useState } from 'react';
import { PageTracker } from '../components/PageTracker.tsx';

const ApiTest: React.FC = () => {
  const [result, setResult] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const testApi = async (endpoint: string, method: 'GET' | 'POST' = 'GET') => {
    setLoading(true);
    setResult('');

    try {
      // Debug environment variables
      const apiUrl = process.env.REACT_APP_API_URL || "https://findashback.onrender.com";
      const fullUrl = `${apiUrl}${endpoint}`;
      
      console.log('Environment:', {
        NODE_ENV: process.env.NODE_ENV,
        REACT_APP_API_URL: process.env.REACT_APP_API_URL,
        calculatedApiUrl: apiUrl,
        fullUrl
      });

      const options: RequestInit = {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
      };

      if (method === 'POST') {
        options.body = JSON.stringify({ test: 'data', timestamp: Date.now() });
      }

      const response = await fetch(fullUrl, options);
      const data = await response.json();

      setResult(JSON.stringify({
        status: response.status,
        statusText: response.statusText,
        data
      }, null, 2));

    } catch (error: any) {
      setResult(`Error: ${error.message}`);
      console.error('API Test Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <PageTracker pageTitle="API Test" category="dev-utils" />
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">API Test Page</h1>
        
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Environment Debug</h2>
          <pre className="bg-gray-100 p-4 rounded text-sm">
{`NODE_ENV: ${process.env.NODE_ENV}
REACT_APP_API_URL: ${process.env.REACT_APP_API_URL}
Calculated API URL: ${process.env.REACT_APP_API_URL || "https://findashback.onrender.com"}`}
          </pre>
        </div>

        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">API Tests</h2>
          
          <div className="space-y-4 mb-6">
            <button
              onClick={() => testApi('/health')}
              disabled={loading}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:opacity-50 mr-2"
            >
              Test Health (GET)
            </button>
            
            <button
              onClick={() => testApi('/test-cors')}
              disabled={loading}
              className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 disabled:opacity-50 mr-2"
            >
              Test CORS (GET)
            </button>
            
            <button
              onClick={() => testApi('/test-api', 'POST')}
              disabled={loading}
              className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600 disabled:opacity-50 mr-2"
            >
              Test API (POST)
            </button>

            <button
              onClick={() => testApi('/auth/google', 'POST')}
              disabled={loading}
              className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 disabled:opacity-50"
            >
              Test Google Auth (POST)
            </button>
          </div>

          {loading && (
            <div className="text-blue-600 mb-4">Loading...</div>
          )}

          {result && (
            <div className="bg-gray-100 p-4 rounded">
              <h3 className="font-semibold mb-2">Result:</h3>
              <pre className="text-sm overflow-auto">{result}</pre>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ApiTest;
